import { render, staticRenderFns } from "./pieZ.vue?vue&type=template&id=0a05ab7e&scoped=true&"
import script from "./pieZ.vue?vue&type=script&lang=js&"
export * from "./pieZ.vue?vue&type=script&lang=js&"
import style0 from "./pieZ.vue?vue&type=style&index=0&id=0a05ab7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a05ab7e",
  null
  
)

export default component.exports